import { geocodeAddress } from './geocodeAddress';

// Make toggleStoreCardList globally available immediately
window.toggleStoreCardList = function() {
  const map = document.querySelector('#map');
  if (map) {
    if (map.style.display === 'none') {
      map.style.display = 'block';
    } else {
      map.style.display = 'none';
    }
    if (document.querySelector('.store_cards')) {
      document.querySelector('.store_cards').classList.toggle('hidden');
      if (document.querySelector('.store_map__view-list .map__wrapper')) document.querySelector('.store_map__view-list .map__wrapper').classList.toggle('d-none');
      if (document.querySelector('.store_map__view-list .list__wrapper ')) document.querySelector('.store_map__view-list .list__wrapper ').classList.toggle('d-none');
    }
    const availableCount = document.querySelector('.filter_and_search_stores__available_count');
    if (availableCount) availableCount.classList.toggle('hidden');
    const viewListButton = document.querySelector("button[name='view list']");
    if (viewListButton) viewListButton.classList.toggle('hidden');
  }
 }
 

export async function getLocationData(mapData) {
  let locations;
  if (sessionStorage.getItem('StoreLocations') && sessionStorage.getItem('StoreLocationsVersion') == '5') {
    locations = JSON.parse(sessionStorage.getItem('StoreLocations'));
    return locations;
  } else {
    // For api fetch
    const storesResp = await fetch('https://netlify.blacklemon.dk/.netlify/functions/getStores?store=ny-form');
    const apiLocations = await storesResp.json();

    if (!mapData) return locations;
    const locations = [...mapData.locations, ...apiLocations];
    for (const location of locations) {
      if (!location.address.latitude || !location.address.longitude) {
        const geocodedAddress = await geocodeAddress(location.address.address1);
        location.address.longitude = geocodedAddress.longitude;
        location.address.latitude = geocodedAddress.latitude;
      }
    }

    sessionStorage.setItem('StoreLocations', JSON.stringify(locations));
    sessionStorage.setItem('StoreLocationsVersion', '5');
    return locations;
  }
}
export function cleanUpBrokenCharacters(text) {
  if (!text) return;

  text = text.replaceAll('Ã˜', 'Ø').replaceAll('Ã¸', 'ø').replaceAll('Ã¥', 'å').replaceAll('Ã¦', 'æ').replaceAll('Â', '').replaceAll('Ã©', 'é');
  return text;
}

export function addPhoneLink(clone, storePhoneNr) {
  if (window.innerWidth >= 750) {
    if (storePhoneNr.includes('+45')) {
      storePhoneNr = storePhoneNr.slice(3);
    }
    let formattedNumber = storePhoneNr.replace(/(\d{2})/g, '$1 ').trim();
    const appendText = 'Tlf: ';

    if (clone.querySelector('.call a')) {
      clone.querySelector('.call a').textContent = appendText + formattedNumber;
      const linkbase = 'tel:';
      clone.querySelector('.call a').setAttribute('href', linkbase + storePhoneNr);

    }
  } else {
    const linkbase = 'tel:';
    if (clone.querySelector('.call a')) {
      clone.querySelector('.call a').setAttribute('href', linkbase + storePhoneNr);
    }
  }
}

export function findUserLocation(successCallback, errorCallback) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userPosition = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        successCallback(userPosition);
      },
      (error) => {
        console.error('Error getting user location:', error);
        errorCallback();
      }
    );
  } else {
    console.error('Geolocation is not supported.');
    errorCallback();
  }
}

export function findCurrentOpeningStatus(openingHours) {
  if (!openingHours || openingHours === "" || !weekdays || !ts_open || !ts_opensoon || !ts_closed) return "";
  const lines = openingHours.split('\n');
  const openinghoursPerDay = {};
  const newDate = new Date();
  const getDateNumber = newDate.getDay() - 1;
  let status = "";

  // Populate opening hours per day
  lines.forEach(line => {
    const [key, value] = line.split(': ');
    if (!value) return;
    openinghoursPerDay[key.trim()] = value.trim();
  });

  const openinghoursPerDaysArr = Object.entries(openinghoursPerDay);
  const openinghoursPerDayArr = openinghoursPerDaysArr[getDateNumber];
  if (!openinghoursPerDayArr) return;
  const todaysOpeningHours = openinghoursPerDayArr[1];
  if (!todaysOpeningHours) return "";

  // Handle the case when the place is marked closed for the entire day ("Lukket")
  if (todaysOpeningHours === ts_closed) return '<span class="closed">' + ts_closed + '</span>';
  if (todaysOpeningHours === '00.00 - 00.00') return '<span class="closed">' + ts_closed + '</span>';

  // Parse opening and closing times
  if (!todaysOpeningHours.includes(' - ')) return;
  const [opensAt, closesAt] = todaysOpeningHours.split(' - ');
  const [opensHour, opensMinute] = opensAt.split('.').map(Number);
  const [closesHour, closesMinute] = closesAt.split('.').map(Number);

  // Set comparison times for opening, opening soon and closing
  const openTime = new Date(newDate);
  openTime.setHours(opensHour, opensMinute, 0, 0);

  const openSoonTime = new Date(newDate);
  openTime.setHours(opensHour - 1, opensMinute, 0, 0);

  const closeTime = new Date(newDate);
  closeTime.setHours(closesHour, closesMinute, 0, 0);

  // Check if current time is within the opening hours
  if (newDate >= openTime && newDate < closeTime) {
    status = ts_open;
    statusClass = "open";
  } else if (newDate >= openSoonTime && newDate < closeTime) {
    status = ts_opensoon;
    statusClass = "open-soon";
  } else {
    status = ts_closed;
    statusClass = 'closed';
  }

  const openingStatusString = '<span class="' + statusClass + '">' + status + '</span>' + ": " + todaysOpeningHours;

  return openingStatusString;
}


export function addDirectionsLink(clone, storeName) {
  const linkbase = 'https://www.google.com/maps/dir//';
  const linkStoreName = storeName.replaceAll(' ', '%20');
  clone.querySelector('.directions a')?.setAttribute('href', linkbase + linkStoreName);
}

export function getStoreDistance(location, userPos) {
  const storeLat = location['address']['latitude'];
  const storeLong = location['address']['longitude'];
  const userLat = userPos['lat'];
  const userLong = userPos['lng'];
  return calculateDistance(storeLat, storeLong, userLat, userLong);
}
function calculateDistance(lat1, lon1, lat2, lon2) {
  lat1 = parseFloat(lat1);
  lon1 = parseFloat(lon1);
  lat2 = parseFloat(lat2);
  lon2 = parseFloat(lon2);

  if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
    throw new Error('Invalid input: All inputs must be valid numbers');
  }

  const R = 6371; // Radius of the Earth in kilometers
  const dLat = deg2rad(lat2 - lat1);
  const dLon = deg2rad(lon2 - lon1);

  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const distance = roundToTenDecimals(R * c);

  return distance;
}

function roundToTenDecimals(num) {
  if (typeof num === 'number' && isFinite(num)) {
    return parseFloat(num.toFixed(10));
  } else {
    throw new Error('Invalid number');
  }
}
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

window.addEventListener('DOMContentLoaded', async function () {
  if (!location.href.includes('/pages')) {
    return;
  }
  if (!document.querySelector('.store_map__wrapper')) {
    return;
  }

  const denmark = { lat: 56.20279, lng: 10.25049 };
  const infoWindows = [];

  let mapData;
  try {
    mapData = JSON.parse(document.querySelector('#map-data').textContent);
  } catch (e) {
    console.error('Error parsing mapData', e);
  }

  const markerImage = mapData.settings.marker_image || '';
  const clusterMarkerImage = mapData.settings.cluster_image ? mapData.settings.cluster_image : '';
  const userMarkerImage = mapData.settings.user_image ? mapData.settings.user_image : '';
  const markerImageSelected = mapData.settings.marker_image_selected ? mapData.settings.marker_image_selected : '';
  const storeT = mapData.settings.store_single ? mapData.settings.store_single : '';
  const storesT = mapData.settings.stores_plural ? mapData.settings.stores_plural : '';
  let pageRedirection;
  if (document.querySelector('.store_cards')) {
    pageRedirection = document.querySelector('.store_cards').getAttribute('store-details-redirection') || '';
  }
  let locations;
  let filteredLocations;
  let map;
  let selectedStoreName = '';
  let mapMarkers = [];
  const selectedStoreZoom = 15;
  const findUserZoom = 10;

  async function initMap(center, zoom, selectedByMarker = false) {

    locations = await getLocationData(mapData);
    filteredLocations = locations;
    filteredLocations.forEach((loc) => {
      let latitude = loc.address.latitude;
      let longitude = loc.address.longitude;
      if (typeof latitude === 'string') {
        if (latitude.includes(',')) latitude = latitude.replace(',', '.');
        loc.address.latitude = parseFloat(latitude);
      }
      if (typeof longitude === 'string') {
        if (longitude.includes(',')) longitude = longitude.replace(',', '.');
        loc.address.longitude = parseFloat(longitude);
      }
    });
    if (typeof center.lat === 'string') {
      if (center.lat.includes(',')) center.lat = center.lat.replace(',', '.');
      center.lat = parseFloat(center.lat);
    }
    if (typeof center.lng === 'string') {
      if (center.lng.includes(',')) center.lng = center.lng.replace(',', '.');
      center.lng = parseFloat(center.lng);
    }

    if (isNaN(center.lat) || isNaN(center.lng)) throw new Error('Invalid center coordinates: lat and lng must be valid numbers');
    map = new google.maps.Map(document.getElementById('map'), {
      zoom: zoom,
      center: center,
      mapTypeId: 'terrain',
      disableDefaultUI: true,
      styles: [
        {
          elementType: 'geometry',
          stylers: [{ color: '#025582' }]
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#333333' }]
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#00283F' }]
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{ color: '#F0EDEB' }]
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ visibility: 'off' }]
        },

      ]
    });
    removePointsOfInterestFromMap();

    placeMarkers(filteredLocations, markerImage, markerImageSelected, selectedByMarker);
    setupClusters(mapMarkers, clusterMarkerImage);
    initRegionSelect(filteredLocations)
  }

  function removePointsOfInterestFromMap() {
    const styles = {
      hide: [
        {
          featureType: 'poi.business',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'transit',
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
      ],
    };

  }

  function initRegionSelect(filteredLocations) {
    const uniqueRegions = [
      ...new Set(
        locations
          .filter(location => location.region) // Only include objects with a `region` property
          .map(location => location.region)   // Extract the `region` property
      )
    ];
    const storeMapRegion = document.querySelector('.store_map__region');
    if (!storeMapRegion) return;
    const storeMapRegionTrigger = storeMapRegion.querySelector('.custom-select-trigger');
    if (!storeMapRegionTrigger) return;
    if (uniqueRegions.length == 0) return;

    const storeMapRegionListWrapper = storeMapRegion.querySelector('.custom-options');
    if (!storeMapRegionListWrapper) return;

    storeMapRegionListWrapper.innerHTML = '';


    if (storeMapRegionListWrapper.getAttribute('data-label')) {
      const allLabel = storeMapRegionListWrapper.getAttribute('data-label');
      const liAll = document.createElement('li');
      liAll.setAttribute('data-value', 'all');
      liAll.setAttribute('data-label', allLabel);
      liAll.innerText = allLabel;
      storeMapRegionListWrapper.appendChild(liAll);
    }

    uniqueRegions.forEach(region => {
      const newList = document.createElement('li');
      newList.setAttribute('data-value', region?.toLowerCase());
      newList.setAttribute('data-label', region);

      newList.innerText = region;
      storeMapRegionListWrapper.appendChild(newList);
    })

    storeMapRegionTrigger.addEventListener('click', function (el) {
      if (!storeMapRegion.classList.contains('open')) {
        storeMapRegion.classList.add('open')
      }
    })

    document.addEventListener("click", (e) => {
      if (storeMapRegion.classList.contains('open')) {
        if (!storeMapRegion.contains(e.target)) {
          storeMapRegion.classList.remove("open");
        }
      }
    });

    const storeMapRegionLists = storeMapRegionListWrapper.querySelectorAll('li');
    if (!storeMapRegionLists) return;
    const selectTriggerLabel = document.querySelector('.custom-select-trigger span');
    storeMapRegionLists.forEach(mapRegion => {
      mapRegion.addEventListener('click', (reg) => {
        reg.preventDefault();
        const mapRegionData = mapRegion.getAttribute('data-value');
        const mapRegionLabel = mapRegion.getAttribute('data-label');

        if (selectTriggerLabel && mapRegionLabel) selectTriggerLabel.innerText = mapRegionLabel;
        if (document.querySelector('.store_map__region')) document.querySelector('.store_map__region').classList.remove('open');


        if (mapRegionData) {
          const storeMapInput = document.querySelector('.store_map__search input');
          if (storeMapInput) {
            storeMapInput.value = '';
          }
          searchStoreCards('REGION', mapRegionData);
        }

      })
    })
  }
  function initStoreCards() {
    try {
      findUserLocation(
        (userPos) => {
          const disableLocationEl = document.querySelector('.store_cards__location-disabled');
          if (disableLocationEl) disableLocationEl.classList.add('hidden');
          buildLocationCards(filteredLocations, userPos);
          applyEventListenerOnStoreCards();
          document.querySelector('.icon-localize')?.classList.remove('hidden');
        },
        () => {
          buildLocationCards(filteredLocations /* You can provide a default user position here if needed */);
          applyEventListenerOnStoreCards();
        }
      );
    } catch (err) {
      console.warn("error:", err)
    }


    setAvailableStoreCount(filteredLocations);

    //Search eventlisteners
    let typingTimer;
    const doneTypingInterval = 500;
    let input = document.querySelector('.filter_and_search_stores__header input');

    input?.addEventListener('keyup', () => {
      clearTimeout(typingTimer);
      typingTimer = setTimeout(decideSearchType, doneTypingInterval);
    });

    input?.addEventListener('keydown', () => {
      clearTimeout(typingTimer);
    });
    // localization eventlistener
    document.querySelector('.icon-localize')?.addEventListener('click', localizationPrompt);

    //List eventlisteners
    document.querySelector("button[name='view list']")?.addEventListener('click', toggleStoreCardList);
    document.querySelector("button[name='view map']")?.addEventListener('click', toggleStoreCardList);
  }



  await initMap(denmark, 7.5);
  initStoreCards();

  function localizationPrompt() {
    navigator.permissions
      .query({ name: 'geolocation' })
      .then((permissionStatus) => {
        if (permissionStatus.state === 'granted') {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
              deleteMarkers();
              addMarker(latLng, userMarkerImage);
              initMap(latLng, findUserZoom);
            },
            (error) => {
              console.error('Geolocation permission denied or error occurred:', error);
            }
          );
        }
      })
      .catch((error) => {
        console.error('Error checking geolocation permission:', error);
      });
  }


  function decideSearchType() {
    const searchTerm = document.querySelector('.filter_and_search_stores__header input').value;
    const searchTermType = typeof searchTerm;

    if (document.querySelector('.store_map__region')) {
      const defaultRegion = document.querySelector('.store_map__region .custom-options li[data-value="all"]')
      if (defaultRegion) {
        const defaultRegionLabel = defaultRegion.getAttribute('data-label');
        const triggerRegionLabel = document.querySelector('.store_map__region .custom-select-trigger span');
        if (defaultRegionLabel && triggerRegionLabel) triggerRegionLabel.innerHTML = defaultRegionLabel;
      }
    }
    if (searchTerm.length > 0 && !isNaN(Number(searchTerm))) {
      searchStoreCards('ZIP', searchTerm);
    } else if (searchTerm.length > 0 && searchTermType === 'string') {
      searchStoreCards('NAME', searchTerm);
    } else if (searchTerm.length == 0) {
      searchStoreCards('RESET');
    }
  }

  function searchStoreCards(type, searchTerm) {
    filteredLocations = locations.map((location) => {
      if (location['name'] === 'Shop location') {
        return;
      }

      if (type === 'ZIP') {
        if (location['address']['zip'].slice(0, searchTerm.length) === searchTerm) {
          return location;
        }
      } else if (type === 'NAME') {
        const searchAgaints = location['address']['address1'] + ' ' + location['address']['city'] + ' ' + location['name'];
        if (searchAgaints.toUpperCase().includes(searchTerm.toUpperCase())) {
          return location;
        }
      } else if (type === 'REGION') {
        if (searchTerm == 'all') {
          return location;
        }
        else {
          if (location['region']) {
            const searchAgaints = location['region'];
            if (searchAgaints.toUpperCase().includes(searchTerm.toUpperCase())) {
              return location;
            }
          }

        }
      } else if (type === 'RESET') {
        return location;
      }
    });

    document.querySelector('.store_cards').innerHTML = '';
    findUserLocation(
      (userPos) => {
        buildLocationCards(filteredLocations, userPos);
        applyEventListenerOnStoreCards();
      },
      () => {
        buildLocationCards(filteredLocations /* You can provide a default user position here if needed */);
        applyEventListenerOnStoreCards();
      }
    );
    setAvailableStoreCount(filteredLocations);
    deleteMarkers();
    placeMarkers(filteredLocations, markerImage, markerImageSelected);
    setupClusters(mapMarkers, clusterMarkerImage);
  }

  function setMapOnAll(map) {
    map = null;
    for (let i = 0; i < mapMarkers.length; i++) {
      mapMarkers[i].setMap(map);
    }
  }

  function deleteMarkers() {
    setMapOnAll(null);
    mapMarkers = [];
  }

  function findlocationIndex() {
    let i = 0;
    let result;
    if (!filteredLocations) {
      return {};
    }

    filteredLocations.forEach((location) => {
      if (location == null) {
        i++;
      } else if (selectedStoreName.toUpperCase() == cleanUpBrokenCharacters(location['name'].toUpperCase())) {
        result = i;
      } else {
        i++;
      }
    });
    return result;
  }


  async function placeMarkers(filteredLocations, markerImage, markerImageSelected, selectedByMarker) {
    const selectedStoreIndex = findlocationIndex(selectedStoreName);
    filteredLocations = filteredLocations.filter(location => location !== null && location !== undefined);

    for (const [i, location] of filteredLocations.entries()) {
      if (location === undefined) return;
      let latitude = location.address.latitude;
      let longitude = location.address.longitude;
      const latLng = new google.maps.LatLng(latitude, longitude);

      if (selectedStoreIndex == i) {
        const targetStoreCardId = handleizeString(selectedStoreName);
        addMarker(latLng, markerImageSelected, location);
        if (selectedByMarker) selectCardFromPlaceMarker(selectedStoreName, targetStoreCardId);
      } else {
        addMarker(latLng, markerImage, location);
      }
    }
  }

  function selectCardFromPlaceMarker(selectedStoreName, selectedStoreNameId) {
    const allStoreCardsArr = Array.from(document.querySelectorAll('.store_card__wrapper'));
    allStoreCardsArr.forEach((storeCard) => {
      storeCard.setAttribute('data-selected', 'false');
    });
    const targettedCard = allStoreCardsArr.find((storeCard) => storeCard.getAttribute('store-card-id') === selectedStoreNameId);
    targettedCard.setAttribute('data-selected', 'true');
  }

  function addMarker(position, image, location) {
    let mapIcon = document.querySelector('.map_marker svg');
    if (mapIcon) {
      mapIcon = mapIcon.cloneNode(true);
    }
    try {
      const svgString = new XMLSerializer().serializeToString(mapIcon);
      const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`;

      const marker = new google.maps.Marker({
        position: position,
        map: map,
        icon: svgDataUrl,
      });
      if (location != undefined) {
        addMarkerModal(marker, location);
      }
      mapMarkers.push(marker);

    } catch (e) {
      console.warn("error::", e);
    }


  }

  function setupClusters(markers, clusterMarkerImage) {

    const renderer = {
      render: ({ count, position }) =>
        new google.maps.Marker({
          label: { text: String(count), color: 'white', fontSize: '10px' },
          icon: clusterMarkerImage,
          map: map,

          position,
          zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        }),
    };
    /*   markers = new MarkerClusterer({ map, markers, renderer }); */
  }



  function handleizeString(input) {
    if (typeof input !== 'string') throw new Error('HandleizeString input must be type of string!');
    input = input.toLowerCase();
    if (input.includes(' ')) input = input.split(' ').join('-');
    return input;
  }

  function buildLocationCards(filteredLocations, userPos) {
    filteredLocations.map((location) => {
      if (location == null) {
        return;
      }
      if (location['name'] == 'Shop location') {
        return;
      }

      const template = document.querySelector('#store_card__template');
      const clone = template.content.cloneNode(true);

      const storeName = cleanUpBrokenCharacters(location['name']);
      const storeRoad = cleanUpBrokenCharacters(location['address']['address1']);
      let storeZip = cleanUpBrokenCharacters(location['address']['zip']);
      if (storeZip === undefined || storeZip === null) storeZip = cleanUpBrokenCharacters(location['address']['postal_code']);
      if (storeZip === undefined || storeZip === null) storeZip = ''; // If postal_code and zip are undefined, show empty string

      const storeCardId = handleizeString(storeName);
      clone.querySelector('.store_card__wrapper').setAttribute('store-card-id', storeCardId);
      clone.querySelector('.store_card__wrapper').setAttribute('store-card-sid', location.storeId);

      const storeCity = cleanUpBrokenCharacters(location['address']['city']);
      const storeAddress = cleanUpBrokenCharacters(storeRoad) + ', ' + storeZip + ' ' + cleanUpBrokenCharacters(storeCity);
      const storePhoneNr = location['address']['phone'];
      const openingHours = location.openingHours;
      const openingStatusText = findCurrentOpeningStatus(location.openingHours);
      if (userPos) {
        const storeDistance = getStoreDistance(location, userPos);
        clone.querySelector('.store_card__shop_distance span').innerText = storeDistance ? storeDistance.toFixed(2) : '';
      } else {
        clone.querySelector('.store_card__shop_distance').classList.add('hidden');
      }
      clone.querySelector('.store_card__shop_name').innerText = storeName ? storeName : '';
      clone.querySelector('.store_card__shop_address').innerText = storeAddress ? storeAddress : '';
      clone.querySelector('.store_card__shop_info').innerText = openingHours ? openingHours : '';
      clone.querySelector('.store_card__shop_current_opening_status').innerHTML = openingStatusText ? openingStatusText : '';
      setStoreSoMeLinks(clone, location);
      addDirectionsLink(clone, storeName);
      addPhoneLink(clone, storePhoneNr);

      document.querySelector('.store_cards').appendChild(clone);
      if (selectedStoreName != '' && storeName.toUpperCase() === selectedStoreName.toUpperCase()) {
        document.querySelector('.store_cards .store_card__wrapper:last-of-type').dataset.selected = true;
      }
    });
  }

  function setStoreSoMeLinks(clone, location) {
    let instagramLink = '';
    let facebookLink = '';

    if (!location.metafields) return;

    location.metafields.forEach((metafield) => {
      if (metafield.key === 'facebook_link') {
        facebookLink = metafield.value;
      } else if (metafield.key === 'instagram_link') {
        instagramLink = metafield.value;
      }
    });
    if (instagramLink != '') {
      clone.querySelector('.social_links .instagram_link').setAttribute('href', instagramLink);
    }
    if (facebookLink != '') {
      clone.querySelector('.social_links .facebook_link').setAttribute('href', facebookLink);
    }
  }
  function openStoreDetails(selectedStoreId) {
    if (selectedStoreId) {
      if (window.location.href.includes('de-de')) {
        window.location = window.origin + '/de-de' + pageRedirection + '?storeId=' + selectedStoreId;
      }
      else {
        window.location = window.origin + pageRedirection + '?storeId=' + selectedStoreId;
      }
    }
  }

  function applyEventListenerOnStoreCards() {
    document.querySelectorAll('.store_card__wrapper').forEach((store_card) => {
      store_card.addEventListener('click', selectStoreFromCards.bind(store_card));
    });
  }

  function selectStoreFromCards(ev) {
    const target = ev.target;
    if (target.closest('.store_card__icons') || target.classList.contains('.store_card__icons')) return;

    const selectedStore = this;
    document.querySelectorAll('.store_card__wrapper').forEach((store_card) => {
      store_card.dataset.selected = false;
    });
    selectedStoreName = selectedStore.querySelector('.store_card__shop_name').innerText;
    selectedStore.dataset.selected = true;

    const selectedStoreId = selectedStore.getAttribute('store-card-sid') || '';
    openStoreDetails(selectedStoreId);

    if (window.innerWidth < 750) {
      deleteContentFromSelectedStoreMapCard();

      document.querySelectorAll('.store_cards .store_card__wrapper').forEach((card) => {
        if (card.querySelector('.store_card__shop_name').innerText.toUpperCase() == cleanUpBrokenCharacters(selectedStoreName.toUpperCase())) {
          let clone = card.cloneNode(true);
          document.querySelector('.selected_store_map_card').appendChild(clone);
          document.querySelector('.selected_store_map_card .icon-close').addEventListener('click', removeSelectedStoreCardOverlay);
          document.querySelector('.selected_store_map_card').classList.remove('hidden');
          document.querySelector('.selected_store_map_card').querySelector('[data-buttons]').classList.add('flex-wrap', 'overflow-x-auto');
        }
      });
    }
  }

  function deleteContentFromSelectedStoreMapCard() {
    if (document.querySelector('.selected_store_map_card .store_card__wrapper')) {
      document.querySelector('.selected_store_map_card .store_card__wrapper').remove();
    }
  }

  function setAvailableStoreCount(filteredLocations) {
    let count = 0;
    for (node in filteredLocations) {
      if (filteredLocations[node] == null) {
        continue;
      }
      if (filteredLocations[node]['name'] == 'Shop location') {
        continue;
      }
      count++;
    }
    let translationstring;
    if (count == 1) {
      translationstring = storeT;
    } else {
      translationstring = storesT;
    }
    document.querySelector('.filter_and_search_stores__available_count span').innerText = count + ' ' + translationstring;
  }

  function addMarkerModal(marker, location) {
    const storeName = location['name'] ? cleanUpBrokenCharacters(location['name']) : '';
    const storeRoad = location['address']['address1'] ? cleanUpBrokenCharacters(location['address']['address1']) : '';
    const storeZip = location['address']['zip'] ? cleanUpBrokenCharacters(location['address']['zip']) : '';
    const storeCity = location['address']['city'] ? cleanUpBrokenCharacters(location['address']['city']) : '';
    const storeAddress = cleanUpBrokenCharacters(storeRoad) + ', ' + storeZip + ' ' + cleanUpBrokenCharacters(storeCity);

    const contentString = '<div class="map-card"><b class="map-header">' + storeName + '</b><br />' + storeAddress + '<br /></div>';

    const infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 300,
    });

    infoWindows.push(infowindow);

    marker.addListener('click', () => {
      document.querySelectorAll('.store_card__wrapper').forEach((store_card) => {
        store_card.dataset.selected = false;
      });

      if (isInfoWindowOpen(infowindow)) {
        if (infowindow.anchor != marker) {
          closeAllInfoWindows(infoWindows);
          infowindow.open(map, marker);
        } else {
          infowindow.close();
        }
      } else {
        closeAllInfoWindows(infoWindows);
        infowindow.open(map, marker);
      }
      setTimeout(() => {
        setupSelectStoreByMarker();
      }, '500');
    });
  }

  function setupSelectStoreByMarker() {
    document.querySelectorAll('.store_card__wrapper').forEach((store_card) => {
      store_card.dataset.selected = false;
    });

    document.querySelectorAll('.selected_store_page__services__wrapper .service_card').forEach((card) => {
      if (!card.classList.contains('hidden')) {
        card.classList.add('hidden');
      }
    });
    if (document.querySelector('.selected_store_page__services')) {
      document.querySelector('.selected_store_page__services').classList.add('hidden');
    }
    let selectedStoreId;
    const selectedStore = document.querySelector('.map-header');
    if (!selectedStore) return;
    selectedStoreName = selectedStore.innerText;
    document.querySelectorAll('.store_card__wrapper').forEach((card) => {
      if (card.querySelector('.store_card__shop_name').innerText.toUpperCase() == cleanUpBrokenCharacters(selectedStoreName.toUpperCase())) {
        selectedStoreId = card.getAttribute('store-card-sid') || '';
        card.dataset.selected = true;
      }
    });
    const storeIndex = findlocationIndex();
    const latlng = { lat: filteredLocations[storeIndex]['address']['latitude'], lng: filteredLocations[storeIndex]['address']['longitude'] };
    deleteMarkers();
    initMap(latlng, selectedStoreZoom, true);

    if (window.innerWidth < 750) {
      deleteContentFromSelectedStoreMapCard();
      document.querySelectorAll('.store_card__wrapper').forEach((card) => {
        if (card.querySelector('.store_card__shop_name ').innerText.toUpperCase() == cleanUpBrokenCharacters(selectedStoreName.toUpperCase())) {
          let clone = card.cloneNode(true);
          document.querySelector('.selected_store_map_card').appendChild(clone);
          const iconCloseElement = document.querySelector('.selected_store_map_card .icon-close');
          if (iconCloseElement) {
            iconCloseElement.addEventListener('click', removeSelectedStoreCardOverlay);
          }
          document.querySelector('.selected_store_map_card .open_store_page').addEventListener('click', function () {
            openStoreDetails(selectedStoreId)
          });
          document.querySelector('.selected_store_map_card').classList.remove('hidden');
          document.querySelector('.selected_store_map_card').querySelector('[data-buttons]').classList.add('overflow-x-auto', 'pb-1');
        }
      });
    }
    openStoreDetails(selectedStoreId);

  }

  function removeSelectedStoreCardOverlay() {
    document.querySelector('.selected_store_map_card .store_card__wrapper').remove();
    document.querySelector('.selected_store_map_card').classList.add('hidden');
  }

  function isInfoWindowOpen(infowindow) {
    var map = infowindow.getMap();
    return map !== null && typeof map !== 'undefined';
  }

  function closeAllInfoWindows(infoWindows) {
    for (var i = 0; i < infoWindows.length; i++) {
      infoWindows[i].close();
    }
  }
});
